<template>
  <div class="page">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "page"
}
</script>
<style lang="scss" scoped>
.page{
  height: 100%;
  flex: 1;
  margin-left: 6px;
  margin-right: 6px;
  overflow: hidden;
}
</style>
